import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { IbComponentsModule } from 'ib/internetbank-core/ib-components/ib-components.module';
import { IbPipesModule } from 'ib/internetbank-core/ib-pipes/ib-pipes.module';
import { InternetbankFieldsModule } from 'ib/internetbank-fields/internetbank-fields.module';


import { CommonAppModule } from '../../../../common/common-app.module';
import { SvgCommonModule } from '../../../../shared/svg/svg-common.module';
import { UiModule } from '../../../../ui/ui.module';
import { BirthCertificateFieldModule } from '../../../settings/tabs/settings-tab-3/birth-certificate-field/birth-certificate-field.module';


import { ChargeItemComponent } from './shared/charge-item/charge-item.component';
import { ChargeListComponent } from './shared/charge-list/charge-list.component';
import { ChargeWidgetComponent } from './shared/charge-widget/charge-widget.component';
import { WidgetEducationComponent } from './widget-education/widget-education.component';
import { WidgetFinesComponent } from './widget-fines/widget-fines.component';
import { WidgetGroupComponent } from './widget-group/widget-group.component';
import { WidgetPaymentCategoryComponent } from './widget-payment-category/widget-payment-category.component';
import { WidgetTaxComponent } from './widget-tax/widget-tax.component';

@NgModule({
	imports: [
		CommonModule,
		CommonAppModule,
		UiModule,
		RouterModule,
		SvgCommonModule,
		InternetbankFieldsModule,
		IbComponentsModule,
		IbPipesModule,
		BirthCertificateFieldModule,
	],
	declarations: [
		WidgetTaxComponent,
		WidgetFinesComponent,
		WidgetEducationComponent,

		WidgetGroupComponent,
		WidgetPaymentCategoryComponent,

		ChargeItemComponent,
		ChargeListComponent,
		ChargeWidgetComponent,
	],
	exports: [
		WidgetTaxComponent,
		WidgetFinesComponent,
		WidgetEducationComponent,

		WidgetGroupComponent,
		WidgetPaymentCategoryComponent,
	],
})
export class PaymentWidgetsModule { }
